import { baseApi } from '@/config/axios';
import {
  SubscriptionPlansResponse,
  SubscriptionApplyParams,
  SubscriptionApplyResponse,
  SubscriptionStatusResponse,
  SubscriptionCancelParams,
  SubscriptionCancelResponse,
} from '@/types/api/subscription';

/** サブスクプラン一覧取得 */
export const getSubscriptionPlansApi = (): Promise<SubscriptionPlansResponse> =>
  baseApi.get('/v1/customer/subscription/plans');

/** サブスク申込 */
export const postSubscriptionApplyApi = (
  params: SubscriptionApplyParams,
): Promise<SubscriptionApplyResponse> =>
  baseApi.post('/v1/customer/subscription/apply', params);

/** 初回決済処理 */
export const postSubscriptionInitialPaymentApi = (params: {
  t_subscription_id: number;
  m_payment_type_id: number;
  m_payment_method_id: number;
}): Promise<any> =>
  baseApi.post('/v1/customer/subscription/initial-payment', params);

/** 継続決済登録完了 → 有効化 */
export const postSubscriptionActivateApi = (params: {
  t_subscription_id: number;
  m_payment_type_id: number;
  m_payment_method_id: number;
}): Promise<any> => baseApi.post('/v1/customer/subscription/activate', params);

/** メーカー一覧取得 */
export const getSubscriptionMakersApi = (): Promise<any> =>
  baseApi.get('/v1/customer/subscription/makers');

/** 車種一覧取得 */
export const getSubscriptionCarnamesApi = (mkCd: number): Promise<any> =>
  baseApi.get('/v1/customer/subscription/carnames', {
    params: { mk_cd: mkCd },
  });

/** 決済方法変更 */
export const postSubscriptionChangePaymentApi = (params: {
  t_subscription_id: number;
  m_payment_type_id: number;
  m_payment_method_id: number;
}): Promise<any> =>
  baseApi.post('/v1/customer/subscription/change-payment', params);

/** サブスク契約状態取得 */
export const getSubscriptionStatusApi = (
  mCustomerId: number,
): Promise<SubscriptionStatusResponse> =>
  baseApi.get('/v1/customer/subscription/status', {
    params: { m_customer_id: mCustomerId },
  });

/** 車検証登録後の車両紐付け */
export const postSubscriptionRegisterVehicleApi = (params: {
  t_subscription_id: number;
  t_stock_car_id: number;
}): Promise<any> =>
  baseApi.post('/v1/customer/subscription/register-vehicle', params);

/** 解約申込 */
export const postSubscriptionCancelApi = (
  params: SubscriptionCancelParams,
): Promise<SubscriptionCancelResponse> =>
  baseApi.post('/v1/customer/subscription/cancel', params);
